module.exports = __webpack_public_path__ + "static/media/06_control_interface.4e43832b.gif";